module.exports = __webpack_public_path__ + "static/media/home-section-1.bbecad40.png";